import { useCallback } from 'react'
import { toast } from 'sonner'

/** settings reuses the onboarding forms, which take an onSuccess callback.
 * in onboarding that advances to the next step. here a save is terminal, so
 * we just confirm with a toast and stay on the page. the forms already
 * invalidate their own query + ['setup'], so the UI reflects the save.
 */
export function useSettingsSave(message = 'Changes saved') {
  return useCallback(() => {
    toast.success(message)
  }, [message])
}
